// @flow

import * as Local from './Local'

export default class Translation {
  static _currentLocalKey = 'de_DE'
  static _currentLocal = Local.de_DE
  static _fallbackLocalKey = 'de_DE'
  static _fallbackLocal = Local.de_DE

  static setFallbackLocal (localKey: string): void {
    const local = Local[localKey]

    if (local) {
      Translation._fallbackLocalKey = localKey
      Translation._fallbackLocal = local

      return
    }

    Translation._fallbackLocalKey = 'de_DE'
    Translation._fallbackLocal = Local.de_DE
  }

  static setLocal (localKey: string): void {
    const local = Local[localKey]

    if (local) {
      Translation._currentLocalKey = localKey
      Translation._currentLocal = local

      return
    }

    Translation._currentLocalKey = 'de_DE'
    Translation._currentLocal = Local.de_DE
  }

  static getText (key: string, vars?: Object): string {
    let text =
      Translation._currentLocal[key] || Translation._fallbackLocal[key] || `translation missing for key "${key}"`

    if (vars) {
      const regex = new RegExp(`\\{(${Object.keys(vars).join('|')})\\}`, 'g')

      text = text.replace(regex, varKey => vars[varKey.replace(/[{}]/g, '')])
    }

    return text
  }
}
